import { metaTags } from '@@/nuxt-config/meta'
import { IS_MAINNET, IS_TESTNET } from '@shared/utils/constant'

export const REFERRAL_CONTRACT_ADDRESS = IS_MAINNET
  ? 'inj1h0al4r880qqzkq8kwhrylzums336ggzhsdanyr'
  : IS_TESTNET
    ? 'inj13m90md73kyg90rmuluvjj7qcukeltrkdvs90jl'
    : 'inj12xk7d7lksh6z94vvt4qqur765trqdcn7sc7uw5'

export const REFERRAL_URL_PREFIX = `${metaTags.url}/ref/`

export const REFERRAL_VOLUME_THRESHOLD_USD = '10000'
